/**
 * Het sessie-id van de quiz meegeven aan de bestelling.
 *
 * Zonder dit is er geen omzetcijfer per advies. De quiz weet wel dat iemand doorklikte, maar niet
 * of hij ook kocht - en dat is precies het tabblad dat Guus wil zien (2026-08-30).
 *
 * De keten:
 *
 *   1. De quiz hangt ?heko_quiz=<sessie> aan de link naar het product.
 *   2. Dit script vangt dat op, waar dan ook op de site, en onthoudt het.
 *   3. Het zet het als kenmerk op de winkelwagen. Shopify neemt kenmerken over op de bestelling,
 *      waar ze via de Admin API als note_attributes terug te lezen zijn.
 *   4. Bij het analyseren hashen we het kenmerk met dezelfde functie als het logboek, en dan
 *      valt de bestelling op zijn sessie.
 *
 * WAAROM EEN KENMERK EN GEEN COOKIE OF UTM. Een kenmerk hoort bij de winkelwagen en overleeft
 * daarmee precies zolang als de aankoop duurt - ook als de klant tussendoor de site verlaat en
 * later terugkomt op dezelfde wagen. Een UTM-parameter overleeft de eerste doorklik niet, en een
 * cookie zou een toestemmingsvraag opleveren voor iets wat geen persoonsgegeven is.
 *
 * BEWAARTERMIJN. Het id blijft dertig dagen staan. Dat is ruim boven de mediane tijd tot aankoop
 * die de huidige keuzehulp laat zien (ruim twintig uur), en het voorkomt dat een advies van
 * maanden geleden nog omzet naar zich toe trekt.
 */
(function () {
  var SLEUTEL = "heko-quiz-order";
  var PARAM = "heko_quiz";
  var DAGEN = 30;

  function onthoud(id) {
    try {
      localStorage.setItem(SLEUTEL, JSON.stringify({ id: id, op: Date.now() }));
    } catch (e) {}
  }

  function opgehaald() {
    try {
      var rauw = localStorage.getItem(SLEUTEL);
      if (!rauw) return null;
      var d = JSON.parse(rauw);
      if (!d || !d.id) return null;
      if (Date.now() - d.op > DAGEN * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(SLEUTEL);
        return null;
      }
      return d.id;
    } catch (e) {
      return null;
    }
  }

  /**
   * Het kenmerk op de winkelwagen zetten.
   *
   * Alleen als het er nog niet op staat, en alleen als er iets in de wagen zit: een lege wagen
   * met een kenmerk erop is geen bestelling in wording en zou de cijfers vervuilen met mensen die
   * alleen keken.
   */
  function zetOpWagen(id) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (wagen) {
        if (!wagen || !wagen.item_count) return;
        if (wagen.attributes && wagen.attributes[PARAM] === id) return;
        var attrs = {};
        attrs[PARAM] = id;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ attributes: attrs }),
        });
      })
      .catch(function () {
        // Een winkel zonder /cart.js of een netwerkfout: dan geen kenmerk. Liever een bestelling
        // die we niet kunnen koppelen dan een script dat de winkelwagen in de weg zit.
      });
  }

  // Komt de bezoeker binnen met het id in de URL, dan onthouden we het meteen.
  try {
    var uit = new URL(window.location.href).searchParams.get(PARAM);
    if (uit) onthoud(uit);
  } catch (e) {}

  var id = opgehaald();
  if (!id) return;

  zetOpWagen(id);

  // En opnieuw zodra er iets in de wagen komt. Wie op de productpagina binnenkwam had nog een
  // lege wagen, en dan deed de poging hierboven niets.
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute("action") || "")) {
      setTimeout(function () { zetOpWagen(id); }, 900);
    }
  }, true);

  // De meeste thema's, Eurus ook, leggen toevoegen aan de wagen via fetch af in plaats van via een
  // formulier. Daarom kijken we ook mee met fetch: gaat er een verzoek naar /cart/add, dan zetten
  // we het kenmerk er daarna op.
  var origFetch = window.fetch;
  if (typeof origFetch === "function") {
    window.fetch = function (invoer, opties) {
      var adres = typeof invoer === "string" ? invoer : (invoer && invoer.url) || "";
      var raakt = /\/cart\/add/.test(adres);
      var uitkomst = origFetch.apply(this, arguments);
      if (raakt) uitkomst.then(function () { setTimeout(function () { zetOpWagen(id); }, 300); }).catch(function () {});
      return uitkomst;
    };
  }
})();
